// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__-+tKo","partnersList":"Partner_partnersList__QuO9-","logo":"Partner_logo__EGDwQ","namePartner":"Partner_namePartner__XI3Ns"};